/**
 * VSlider parser: delegates to the shared Slider base (Control, Range and the tick and editable
 * properties). VSlider adds no properties. Only the draw axis differs, which is the Component's
 * business.
 */
import { parseSlider } from '../shared/slider';
export function parseVSlider(heading, properties) {
    return parseSlider(heading, properties);
}
//# sourceMappingURL=parser.js.map